export const engagementSegmentsWorkflowsForLinkSegmentation =
  "/engagement/segments/workflows_for_link_segmentation";
